import { useCallback, useLayoutEffect, useRef } from "react";

/** A tab or section switch starts at the top (polish round one, the founder's list of 2026-10-16; DECISIONS 2026-10-16). A screen hands the
 *  hook what decides its content (the tab, the section, a list's segment, filters and sort) and puts the returned ref on its scroller, on an
 *  element inside it, or on the pane around a list whose scroller is the kit's; when the key changes, that element, every scrolling element
 *  inside it and above it up to the page, and the document (the scroller on a phone) go back to the top. The first render does nothing: a new
 *  screen gets a new scroller anyway. The inbox keeps its own memory (`useListScrollMemory`), the ticket pane and a chat room their fresh
 *  scrollers; none of them uses this. */
export function useScrollReset(key: unknown): (el: HTMLElement | null) => void {
  const node = useRef<HTMLElement | null>(null);
  const first = useRef(true);
  const k = typeof key === "string" ? key : JSON.stringify(key);
  useLayoutEffect(() => {
    if (first.current) { first.current = false; return; }
    scrollToTop(node.current);
  }, [k]);
  return useCallback((el: HTMLElement | null) => { if (el) node.current = el; }, []); // the last element stays known while its content reloads
}

const scrolls = (el: HTMLElement) => { const o = getComputedStyle(el).overflowY; return o === "auto" || o === "scroll"; };
/** the element, what scrolls inside it and every scrolling ancestor up to the app's body, then the document, at the top */
function scrollToTop(from: HTMLElement | null) {
  if (!from?.isConnected) return;
  for (const el of from.querySelectorAll<HTMLElement>("*")) if (el.scrollTop > 0) el.scrollTop = 0; // only a scrolled element has a position
  for (let el: HTMLElement | null = from; el && el !== document.body; el = el.parentElement) if (el.scrollTop > 0 && scrolls(el)) el.scrollTop = 0;
  const doc = document.scrollingElement as HTMLElement | null;
  if (doc && doc.scrollTop > 0) doc.scrollTop = 0;
}
